import { getQueryParam } from '../routing/getQueryParam';
import enviro from 'enviro';
export const getShouldUseBreezeCompanyInfo = () => {
  const isQA = enviro.isQa();
  return getQueryParam('breeze_company_info_enabled') === 'true' && isQA;
};